import ModuleBootstrapper from '../common/ModuleBootstrapper/ModuleBootstrapper';

import ListInterestRegistrations from './containers/ListInterestRegistrations';
import ViewInterestRegistration from './containers/ViewInterestRegistration';

const routes = [
    {
        type: 'crud',
        list: ListInterestRegistrations,
        view: ViewInterestRegistration
    }
]

export default ModuleBootstrapper.getRoutes("interest-registrations", routes)
